// Vendor Libs
import React, {useContext} from 'react';
import PropTypes from 'prop-types';

// Dish React Library
import {CheckAuthSession} from '@dishtech-react/core';

// Material UI
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FaceIcon from '@material-ui/icons/Face';
import MenuIcon from '@material-ui/icons/Menu';
import PeopleIcon from '@material-ui/icons/People';
import WorkIcon from '@material-ui/icons/Work';
import {CssBaseline, Divider, List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

// Components
import Content from '../nav/content';
import Footer from '../nav/footer';
import Header from '../nav/header';
import Root from '../nav/root';
import Nav from '../nav/nav';

// Contexts
import {RouteContext} from '../../../contexts/route-context';

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: '90px',
    },
    list: {
        paddingTop: '0px',
    },
    toolbar: theme.mixins.toolbar,
}));

const config = {
    navAnchor: 'left',
    navVariant: 'persistent',
    navWidth: 200,
    collapsible: true,
    collapsedWidth: 64,
    clipped: true,
    headerPosition: 'sticky',
    squeezed: true,
    footerShrink: true,
};

const MainNav = ({children}) => {
    const classes = useStyles();
    const routeContext = useContext(RouteContext);

    return (
        <Root className={classes.root} config={config}>
            <CheckAuthSession />
            <CssBaseline />
            <Header
                menuIcon={{
                    inactive: <MenuIcon />,
                    active: <ChevronLeftIcon />,
                }}
            />
            <Nav
                collapsedIcon={{
                    inactive: <ChevronLeftIcon />,
                    active: <ChevronRightIcon />,
                }}
                header={
                    // provide fixed header inside nav
                    // change _ctx -> headerContext and null to some react element
                    _ctx => null
                }
            >
                <div className={classes.toolbar} />
                <List className={classes.list}>
                    <ListItem button={true} onClick={() => routeContext.push('/client')}>
                        <ListItemIcon>
                            <WorkIcon />
                        </ListItemIcon>
                        <ListItemText primary="Clients" />
                    </ListItem>
                    <ListItem button={true} onClick={() => routeContext.push('/role')}>
                        <ListItemIcon>
                            <FaceIcon />
                        </ListItemIcon>
                        <ListItemText primary="Roles" />
                    </ListItem>
                    <ListItem button={true} onClick={() => routeContext.push('/user')}>
                        <ListItemIcon>
                            <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Users" />
                    </ListItem>
                    <Divider />
                </List>
            </Nav>
            <Content>{children}</Content>
            <Footer>{/* footer goes here */}</Footer>
        </Root>
    );
};

MainNav.propTypes = {
    children: PropTypes.node,
};

export default MainNav;
